import { useMutation } from "react-query";

import { dropdownValuesService } from "services";

type UseAgentOfficesQueryProps = {
	options?: any;
};

const useAgentOfficesWithPagingQuery = ({
	options,
}: UseAgentOfficesQueryProps = {}) =>
	useMutation(
		({
			pattern,
			page_index,
			page_size,
		}: {
			pattern?: string;
			page_index?: number;
			page_size?: number;
		}) =>
			dropdownValuesService.getAgentOfficesResiduals(
				pattern,
				page_index,
				page_size,
			),
		{
			...options,
		},
	);

export default useAgentOfficesWithPagingQuery;
